/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPPROPOSALPROGRESS } from './IAPPROPOSALPROGRESS';
import {
    IAPPROPOSALPROGRESSFromJSON,
    IAPPROPOSALPROGRESSFromJSONTyped,
    IAPPROPOSALPROGRESSToJSON,
} from './IAPPROPOSALPROGRESS';
import type { PagingArgs } from './PagingArgs';
import {
    PagingArgsFromJSON,
    PagingArgsFromJSONTyped,
    PagingArgsToJSON,
} from './PagingArgs';
import type { ProposalFilterType } from './ProposalFilterType';
import {
    ProposalFilterTypeFromJSON,
    ProposalFilterTypeFromJSONTyped,
    ProposalFilterTypeToJSON,
} from './ProposalFilterType';
import type { SortDirection } from './SortDirection';
import {
    SortDirectionFromJSON,
    SortDirectionFromJSONTyped,
    SortDirectionToJSON,
} from './SortDirection';

/**
 * 
 * @export
 * @interface GetProposalsForOverviewQuery
 */
export interface GetProposalsForOverviewQuery {
    /**
     * 
     * @type {string}
     * @memberof GetProposalsForOverviewQuery
     */
    orderBy: string;
    /**
     * 
     * @type {SortDirection}
     * @memberof GetProposalsForOverviewQuery
     */
    sortDirection: SortDirection;
    /**
     * 
     * @type {PagingArgs}
     * @memberof GetProposalsForOverviewQuery
     */
    pagingArgs?: PagingArgs;
    /**
     * 
     * @type {string}
     * @memberof GetProposalsForOverviewQuery
     */
    searchTerm?: string;
    /**
     * 
     * @type {IAPPROPOSALPROGRESS}
     * @memberof GetProposalsForOverviewQuery
     */
    progressFilter?: IAPPROPOSALPROGRESS;
    /**
     * 
     * @type {ProposalFilterType}
     * @memberof GetProposalsForOverviewQuery
     */
    typeFilter?: ProposalFilterType;
}

/**
 * Check if a given object implements the GetProposalsForOverviewQuery interface.
 */
export function instanceOfGetProposalsForOverviewQuery(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "orderBy" in value;
    isInstance = isInstance && "sortDirection" in value;

    return isInstance;
}

export function GetProposalsForOverviewQueryFromJSON(json: any): GetProposalsForOverviewQuery {
    return GetProposalsForOverviewQueryFromJSONTyped(json, false);
}

export function GetProposalsForOverviewQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProposalsForOverviewQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'orderBy': json['OrderBy'],
        'sortDirection': SortDirectionFromJSON(json['SortDirection']),
        'pagingArgs': !exists(json, 'PagingArgs') ? undefined : PagingArgsFromJSON(json['PagingArgs']),
        'searchTerm': !exists(json, 'SearchTerm') ? undefined : json['SearchTerm'],
        'progressFilter': !exists(json, 'ProgressFilter') ? undefined : IAPPROPOSALPROGRESSFromJSON(json['ProgressFilter']),
        'typeFilter': !exists(json, 'TypeFilter') ? undefined : ProposalFilterTypeFromJSON(json['TypeFilter']),
    };
}

export function GetProposalsForOverviewQueryToJSON(value?: GetProposalsForOverviewQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'OrderBy': value.orderBy,
        'SortDirection': SortDirectionToJSON(value.sortDirection),
        'PagingArgs': PagingArgsToJSON(value.pagingArgs),
        'SearchTerm': value.searchTerm,
        'ProgressFilter': IAPPROPOSALPROGRESSToJSON(value.progressFilter),
        'TypeFilter': ProposalFilterTypeToJSON(value.typeFilter),
    };
}

